import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { selectors, actions } from 'builder/modules/careerProfile'
import { FetchStatuses } from 'builder/modules/constants'
import { useIsCareerProfileAvailable } from './useIsCareerProfileAvailable'

export const useCareerProfileCompleteness = (isForceDisabled?: boolean) => {
  const dispatch = useDispatch()

  const isAvailable = useIsCareerProfileAvailable()
  const shouldInit = isAvailable && !isForceDisabled
  const fetchStatus = useTypedSelector(selectors.completenessFetchStatus)
  const completenessPercent = useTypedSelector(selectors.completenessPercent)
  const isCareerProfileCompletenessLoading = fetchStatus === FetchStatuses.loading

  useEffect(() => {
    if (shouldInit && fetchStatus === FetchStatuses.notAsked) {
      dispatch(actions.fetchCompleteness())
    }
  }, [shouldInit, fetchStatus, dispatch])

  return {
    completenessPercent,
    isCareerProfileCompletenessLoading,
  }
}
